/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'credit-note': {
    width: 12,
    height: 9,
    viewBox: '0 0 12 9',
    data: '<g _stroke="#404040" _fill="none" fill-rule="evenodd"><path pid="0" d="M6.945 6.189H9.52M10.532 7.878H1.675a.567.567 0 0 1-.572-.561V1.644c0-.31.256-.562.572-.562h8.857c.316 0 .571.252.571.562v5.673c0 .31-.255.561-.571.561z"/><path pid="1" d="M1.103 2.579h10v1.475h-10z"/></g>'
  }
})
